import mongoose from 'mongoose';
export function repositoryForSchema(schema) {
    return mongoose.models[schema.options.alias];
}
